export const AdPageTestIds = {
  missingAd: {
    container: 'ad-missing-notice',
    title: 'ad-missing-notice-title',
    description: 'ad-missing-notice-description',
  },
  price: 'ad-price',
  title: 'ad-title',
  description: 'ad-description',
  contactNumber: 'ad-contact-number',
  advertiseButton: 'advertise-button',
  propertiesItem: 'properties-item',
  propertiesItemLabel: 'properties-item-label',
  propertiesItemValue: 'properties-item-value',
  categoryWarning: 'ad-category-warning',
  categoryWarningText: 'ad-category-warning-text',
  slider: {
    counter: 'slider-counter',
    image: 'slider-image',
  },
  authorInfo: {
    main: 'author-info-main',
    name: 'author-info-name',
    workingHours: 'author-info-working-schedule',
    link: 'author-info-link',
    avatar: 'author-info-avatar',
    defaultAvatar: 'author-info-default-avatar',
  },
  complaint: {
    box: 'complaint-box',
    title: 'complaint-title',
    reportReason: 'complaint-report-reason',
    textarea: 'complaint-textarea',
    submit: 'complaint-submit',
    popup: 'complaint-popup',
  },
  statusBanner: {
    banner: 'status-banner',
    text: 'status-banner-text',
    button: 'status-banner-button',
    restoredAdWindow: 'status-banner-restored-ad-window',
    restoredAdWindowBtn: 'status-banner-restored-ad-window-btn',
    restoredAdPopup: 'status-banner-restored-ad-popup',
    payByBalancePopup: 'status-banner-pay-by-balance-popup',
    prolongByBalancePopup: 'status-banner-prolong-by-balance-popup',
  },
  remove: {
    sheet: 'ad-remove-sheet',
    reasonsNextButton: 'ad-remove-reasons-next',
    continueButton: 'ad-remove-continue',
    submitButton: 'ad-remove-submit',
    descriptionInput: 'ad-remove-description',
  },
  statistics: {
    adNumber: 'stats-ad-number',
    views: 'stats-views',
    daysToDeactivation: 'stats-days-to-deactivation',
    updatedAt: 'stats-updated-at',
    contacts: {
      self: 'stats-contacts',
      tooltip: 'stats-contacts-tooltip',
      questionIcon: 'stats-contacts-question-icon',
    },
    inFavorites: 'stats-in-favorites',
  },
  settings: {
    editButton: 'setting-edit-button',
    remove: {
      button: 'setting-remove-button',
      popup: 'setting-remove-popup',
    },
    editPopup: 'setting-edit-popup',
    editPendingPopup: 'setting-edit-pending-popup',
  },
  chatButton: 'chat-button',
  callButton: 'call-button',
  promotions: {
    box: 'promotions-box',
  },
  promotionButton: {
    bump: 'promotion_bumped',
    vip: 'promotion_vipped',
    premium: 'promotion_premium',
    bumpIsAuthor: 'isAuthor_promotion_bumped',
    vipIsAuthor: 'isAuthor_promotion_vipped',
    premiumIsAuthor: 'isAuthor_promotion_premium',
  },
  promotionFlow: {
    window: 'promotion-window',
    services: 'promotion-drawer-services',
    payButton: 'promotion-drawer-pay-button',
    bonusLabel: 'promotion-drawer-bonus-label',
    subheader: {
      subtitle: 'promotion-drawer-subheader-subtitle',
      row1Text: 'promotion-drawer-subheader-row1-text',
      row1Message: 'promotion-drawer-subheader-row1-message',
      row2Text: 'promotion-drawer-subheader-row2-text',
      row2Message: 'promotion-drawer-subheader-row2-message',
    },
    terminalPaymentDrawer: 'promotion-drawer-terminal-payment-drawer',
  },
  terminalPaymentDrawer: {
    drawer: 'terminal-payment-drawer',
    phone: 'terminal-payment-drawer-phone',
    service: 'terminal-payment-drawer-service',
    price: 'terminal-payment-drawer-price',
    okButton: 'terminal-payment-drawer-ok-button',
  },
  popup: {
    success: 'popup-success',
    restoredSuccess: 'popup-restored-success',
    notEnoughFunds: 'popup-not-enough-funds',
    payByBalance: 'popup-pay-by-balance',
    prolongByBalance: 'prolong-pay-by-balance',
  },
  myCards: {
    triggerButton: 'my-cards-trigger-button',
    window: {
      self: 'my-cards-window',
      card: 'my-cards-window-card',
    },
  },
  paymentFlow: {
    window: 'payment-flow-window',
    promotionFlow: 'payment-flow-window-promotion-window',
    continueButton: 'payment-flow-window-continue-button',
    restoredAdPopup: 'payment-flow-window-restored-ad-popup',
  },
  paymentProviderIcons: {
    googlePayIcon: 'google-pay-icon',
    applePayIcon: 'apple-pay-icon',
  },
  addBalance: {
    window: 'add-balance-window',
    button: 'add-balance-window-button',
    errorDrawer: 'add-balance-error-drawer',
  },
  headerActions: {
    bookmarkIcon: 'header-actions-bookmark-icon',
  },
};
